import { render, staticRenderFns } from "./ModalChooseReason.vue?vue&type=template&id=47efa929&scoped=true&"
import script from "./ModalChooseReason.vue?vue&type=script&lang=js&"
export * from "./ModalChooseReason.vue?vue&type=script&lang=js&"
import style0 from "./ModalChooseReason.vue?vue&type=style&index=0&id=47efa929&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efa929",
  null
  
)

export default component.exports